import { differenceInDays } from "date-fns";
import type { VagaListagem } from "@/types/vaga";

/** Verba formatada como faixa em BRL (colunas em centavos). */
export function formatVerba(vaga: VagaListagem): string {
  const brl = (centavos: number) =>
    (centavos / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  if (vaga.verba_minima && vaga.verba_maxima) return `${brl(vaga.verba_minima)} – ${brl(vaga.verba_maxima)}`;
  if (vaga.verba_minima) return `A partir de ${brl(vaga.verba_minima)}`;
  if (vaga.verba_maxima) return `Até ${brl(vaga.verba_maxima)}`;
  return vaga.verba || "—";
}

/**
 * Instante da decisão: aprovação (data_aprovacao) ou reprovação
 * (last_status_changed_at, quando a vaga entrou no status atual). timestamptz.
 */
export function decisaoIso(vaga: VagaListagem): string | null {
  if (vaga.status === "aprovado" && vaga.data_aprovacao) return vaga.data_aprovacao;
  if (vaga.status === "reprovado" && vaga.last_status_changed_at) return vaga.last_status_changed_at;
  return null;
}

/** Delta abreviado entre duas datas: "3d", "1sem", "1sem e 1d", "2mes e 1sem". */
export function formatDeltaAbrev(fromIso: string, toIso: string): string | null {
  const dias = differenceInDays(new Date(toIso), new Date(fromIso));
  if (dias < 0) return null;
  if (dias < 7) return `${dias}d`;
  if (dias < 30) {
    const semanas = Math.floor(dias / 7);
    const resto = dias % 7;
    return resto > 0 ? `${semanas}sem e ${resto}d` : `${semanas}sem`;
  }
  const meses = Math.floor(dias / 30);
  const semanasResto = Math.floor((dias % 30) / 7);
  return semanasResto > 0 ? `${meses}mes e ${semanasResto}sem` : `${meses}mes`;
}
